import React, { Component } from "react";
import { Parser } from "html-to-react";
import Actions from "../../actions/Creators";
import Loader from "../common/loader/Loader";
import I18n from "../../i18n/I18n";
import logoEn from "../../images/logo/seller-lab-logo.svg";
import logoAr from "../../images/logo/seller-lab-logo-arabic.svg";
import styles from "./TncContent.scss";
import Button from "../common/button/Button";

class TncContent extends Component {
  componentDidMount() {
    this.setState(
      { loading: true, errorMessage: null },
      function() {
        this.props.dispatch(
          Actions.getTnC(this.props.countryCode.toLowerCase())
        );
      }.bind(this)
    );
  }
  render() {
    const htmlToReactParser = new Parser();

    return (
      <div className={styles.wrapper} style={{ direction: "ltr" }}>
        <div className={styles.logoWrapper}>
          <div className={styles.logoImg}>
            <img src={logoEn} alt="noon en" />
          </div>
          <div className={styles.logoImg}>
            <img src={logoAr} alt="noon en" />
          </div>
        </div>

        <div className={styles.contentWrapper}>
          {this.props.isLoading ? (
            <Loader />
          ) : this.props.tnc ? (
            htmlToReactParser.parse(this.props.tnc.html)
          ) : (
            ""
          )}
        </div>

        <div className={styles.btnWrapper}>
          <Button variant="primary" onClick={() => this.props.acceptTerms()}>
            {I18n.getText("tnc.accept-tnc", {}, "Accept")}
          </Button>
        </div>
      </div>
    );
  }
}

export default TncContent;



// WEBPACK FOOTER //
// ./src/components/tncContent/TncContent.js